import dayjs from 'dayjs';
import HelloSign from 'hellosign-embedded';
import firebase from '../../../lib/firebase.prod';
import * as ORIGINAL_HREF from '../../../constants/originalHref';
import * as ALL_DOCUMENTS from '../../../constants/helloSignDocumentInfo';
import * as CLIENT_ID from '../../../constants/helloSignClientId';
import * as PROJECT_CODE from '../../../constants/projectCode';
import * as firebaseDocumentCalls from '../../Clients/getFirebaseDocumentInfo.api';
import SaveClientSignatureRequestInfo from '../helloSign/saveClientSignatureRequestInfo.api';
import { getDepositSchedule } from '../getDepositSchedule.api';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;
const signDocument = async (
	leadId,
	client,
	agreementData,
	leadDetails,
	setLoading,
	redirect,
	setAlert
) => {
	const clientInfo = agreementData?.clientInfo;
	const primaryClient = clientInfo?.corporation
		? clientInfo.corporation
		: clientInfo.individual[Object.keys(clientInfo.individual).shift()];

	var currentUserEmail = firebase.auth().currentUser.email;
	var authToken = ORIGINAL_HREF.originalHREF['access_token'];

	if (ALL_DOCUMENTS.allDocumentTypeInfo.hasGottenInfo === false) {
		firebaseDocumentCalls.GetFirebaseDocumentInformation();
	}
	setLoading(true);

	const executeSignDoc = async () => {
		getDepositSchedule(leadId, async (depositSchedule) => {
			var documentInfo =
				ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo;
			var listOptionsString = [];

			var optionSelectedKeys =
				agreementData?.options && Object.keys(agreementData?.options);

			optionSelectedKeys?.forEach((optionSel) => {
				listOptionsString.push(agreementData?.options[optionSel].name);
			});

			var documentData = {
				clientAddress: primaryClient.address1,
				clientZipCode: primaryClient?.zipCode,
				clientDob: primaryClient?.identification?.report?.document
					?.dateOfBirth
					? dayjs(
							primaryClient?.identification?.report?.document
								?.dateOfBirth
					  ).format('DD/MMM/YYYY')
					: null,
				clientFName: primaryClient?.firstName,
				clientLName: primaryClient?.lastName,
				clientIdNumber:
					primaryClient?.primaryClient?.identification?.report
						?.document?.idNumber,
				clientIdType:
					primaryClient.primaryClient?.identification?.report
						?.document?.type,
				clientOccupation: primaryClient?.occupation,
				clientPhoneNumber: primaryClient?.phoneNumber,
				coporationName: primaryClient?.corporationName,
				lotNumber: agreementData.productAvailability.lotId,
				lotClosingDate: agreementData.productAvailability.closingDate,
				lotPrice: agreementData.productAvailability.lotPrice,
				lotSize: agreementData.productAvailability.lotSize,
				lotSizeType: agreementData.productAvailability.lotSizeType,
				modelName: agreementData.productAvailability.modelName,
				modelSize: agreementData.productAvailability.modelSize,
				elevationName: agreementData.productAvailability.elevation.id,
				elevationPrice:
					agreementData.productAvailability.elevation.price,
				options: listOptionsString,
				totalPrice:
					+Number(agreementData.productAvailability?.lotPrice) +
					+Number(
						agreementData.productAvailability?.grade?.price || 0
					) +
					+Number(
						agreementData.productAvailability?.upgrade?.price || 0
					) +
					+Number(agreementData.productAvailability.elevation.price) +
					+Number(agreementData.totalOptions || 0),
				totalPriceFormatted: new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(
					+Number(agreementData.productAvailability?.lotPrice) +
						+Number(
							agreementData.productAvailability?.grade?.price || 0
						) +
						+Number(
							agreementData.productAvailability?.upgrade?.price ||
								0
						) +
						+Number(
							agreementData.productAvailability.elevation.price
						) +
						+Number(agreementData.totalOptions || 0)
				),
			};

			const helloClient = new HelloSign();
			var getDoc = firebase
				.functions()
				.httpsCallable('HelloSignCallDocument');

			var closing_date_hours_extra =
				dayjs(documentData.lotClosingDate).unix() * 1000 + 360000 * 12; //counteract daylight saving s***
			var second_closing_date = closing_date_hours_extra + 86400000 * 120; //.add(120, 'days');//Original Closing Date + 120 days:
			var firm_closing_date = closing_date_hours_extra + 86400000 * 240; //.add(240, 'days');//Original Closing Date + 240 Days:
			var outside_closing_date =
				closing_date_hours_extra + 86400000 * 485; //.add(485, 'days');//Original Closing Date + 120 days  + 365 days:
			var notice_delay = closing_date_hours_extra + 86400000 * -90; //.add(-90, 'days');// Original Closing Date - 90 days:
			var notice_second_delay = closing_date_hours_extra + 86400000 * 30; //.add(30, 'days');// Original Closing Date + 30 days
			var termination_date = closing_date_hours_extra + 86400000 * 635; //.add(635, 'days');// Original Closing date + 240 + 365 + 30:

			var jsonInfo = {
				authToken: authToken,
				senderEmail: currentUserEmail,
				subjectName: documentInfo?.subjectName,
				message: documentInfo?.message,
				projectCode: projectCode,
				templateId:
					documentInfo?.buildingTemplateId[
						agreementData.productAvailability.modelName
					] ||
					ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo
						.buildingTemplateId[
						agreementData.productAvailability.modelName
					],
				clientEmail: leadDetails.clientEmail,
				clienFullName: documentData.clientFName
					? documentData.clientFName + ' ' + documentData.clientLName
					: documentData.coporationName,
				customFields: [
					{
						name: 'buyer_full_name',
						value: documentData.clientFName
							? documentData.clientFName +
							  ' ' +
							  documentData.clientLName
							: documentData.coporationName,
					},
					{
						name: 'building_lot_number',
						value: documentData.lotNumber,
					},
					{
						name: 'model_option',
						value: documentData?.options?.join(', '),
					},
					{
						name: 'closing_date',
						value: dayjs(documentData.lotClosingDate).format(
							'DD/MM/YYYY'
						),
					},
					{
						name: 'display_price_number',
						value: documentData.totalPriceFormatted.substring(1),
					},
					{
						name: 'client_address',
						value: documentData.clientAddress,
					},
					{
						name: 'postal_code',
						value: documentData.clientZipCode,
					},
					{
						name: 'client_email',
						value: leadDetails.clientEmail,
					},
					{
						name: 'client_phone',
						value: documentData.clientPhoneNumber,
					},
					{
						name: 'building_elevation',
						value: documentData.elevationName,
					},
					{
						name: 'postal_code',
						value: leadDetails.postalCode,
					},
					{
						name: 'building_model_number',
						value: documentData.modelName,
					},
					{
						name: 'second_install',
						value: new Intl.NumberFormat().format(
							depositSchedule[1]['installment']?.toFixed(2)
						),
					},
					{
						name: 'third_install',
						value: new Intl.NumberFormat().format(
							depositSchedule[2]['installment']?.toFixed(2)
						),
					},
					{
						name: 'fourth_install',
						value: new Intl.NumberFormat().format(
							depositSchedule[3]['installment']?.toFixed(2)
						),
					},
					{
						name: 'fifth_install',
						value: new Intl.NumberFormat().format(
							depositSchedule[4]['installment']?.toFixed(2)
						),
					},
					{
						name: 'second_closing_date',
						value: dayjs(second_closing_date).format('DD/MM/YYYY'),
					},
					{
						name: 'firm_closing_date',
						value: dayjs(firm_closing_date).format('DD/MM/YYYY'),
					},
					{
						name: 'outside_closing_date',
						value: dayjs(outside_closing_date).format('DD/MM/YYYY'),
					},
					{
						name: 'notice_delay',
						value: dayjs(notice_delay).format('DD/MM/YYYY'),
					},
					{
						name: 'notice_second_delay',
						value: dayjs(notice_second_delay).format('DD/MM/YYYY'),
					},
					{
						name: 'termination_date',
						value: dayjs(termination_date).format('DD/MM/YYYY'),
					},
				],
				overideMetaData: true,
				newMetaData: {
					project_code: projectCode,
					leadId: leadId,
				},
			};

			let individualKeys =
				agreementData?.clientInfo?.individual &&
				Object.keys(agreementData.clientInfo.individual);

			if (individualKeys?.length > 1) {
				let secondaryClient =
					agreementData.clientInfo.individual[individualKeys[1]];
				console.log('secondaryClient', secondaryClient);
				documentData['secondClientFullName'] =
					secondaryClient?.firstName +
					' ' +
					secondaryClient?.lastName;
				documentData['secondClientEmail'] = secondaryClient?.email;
				jsonInfo['secondClientFullName'] =
					secondaryClient?.firstName +
					' ' +
					secondaryClient?.lastName;
				jsonInfo['secondClientEmail'] = secondaryClient?.email;
				jsonInfo['templateId'] =
					documentInfo?.secondPurchaserTemplateId[
						agreementData.productAvailability.modelName
					];

				getDoc = firebase
					.functions()
					.httpsCallable('HelloSignCallDocumentSecondPurchaser');

				var secondfFullNameJson = {
					name: 'second_full_name',
					value:
						secondaryClient?.firstName +
						' ' +
						secondaryClient?.lastName,
				};

				jsonInfo.customFields.push(secondfFullNameJson);
			}

			const displayHelloDoc = (signUrl) => {
				helloClient.open(signUrl, {
					skipDomainVerification: true,
					clientId: CLIENT_ID.clientId,
				});
			};

			var finishedData;

			var clientRef = firebaseRef.ref(
				'/kavtek_agreements/' +
					projectCode +
					'/' +
					leadId +
					'/documentInformation'
			);

			helloClient.on('finish', async () => {
				await SaveClientSignatureRequestInfo(
					firebase,
					finishedData,
					leadDetails.clientEmail,
					ALL_DOCUMENTS.allDocumentTypeInfo.apsFirebaseInfo
						.subjectName,
					leadDetails.leadToSalesAgent,
					leadId
				);

				clientRef
					.update({
						documentStatus: 'sent',
					})
					.then(() => redirect('/deals'));

				var clientParentRef = firebaseRef.ref(
					'/kavtek_agreements/' + projectCode + '/' + leadId
				);

				clientParentRef.update({
					clientEmail: leadDetails.clientEmail,
				});
			});

			helloClient.on('ready', () => {
				clientRef.update({
					documentStatus: 'ready',
				});
			});

			const displayTheAps = () => {
				getDoc(jsonInfo)
					.then((result) => {
						displayHelloDoc(result['data']['claim_url']);
						finishedData = result['data'];
						setLoading(false);
					})
					.catch((error) => {
						console.error('APS creation error ', error);
						setLoading(false);
						setAlert('Something wrong happened. Please try again.');
					});
			};

			displayTheAps();
		});
	};

	setTimeout(() => {
		executeSignDoc();
	}, 100);
};

export default signDocument;
